<template>
    <a :href="post.url">
        <article class="blog-item">
            <div class="blog-item__inner">
                <div class="blog-item__media">
                    <img class="blog-item__image" v-if="post?.image?.src" :src="post.image.src" :alt="post.image.alt || post.title" />
                </div>
                <div class="blog-item__content">
                    <hgroup class="blog-item__heading">
                        <span class="blog-item__category" v-if="post?.categories?.[0]?.title">{{ post.categories[0].title }}</span>
                        <h2 class="blog-item__title">{{ post?.title }}</h2>
                    </hgroup>
                    <div class="blog-post__description">
                        <p v-if="post?.description">{{ post.description }}</p>
                        <div class="blog-item__meta">
                            <span v-if="post?.updatedAt">Posted <time :datetime="post.updatedAt">{{ formatDate(post.updatedAt) }}</time></span>
                            <span v-if="post?.author">By {{ post.author }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </a>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    post: {
        type: Object,
        required: true
    }
});

function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
}
</script>
